import { createMarkup } from "@flexmr/utils";
import { Modal } from "antd";
import * as React from "react";
import { getClassNames as getIconClassNames } from "#Shared/ui/fa-icon.tsx";
import { CloseButton } from "./widgetHelp/CloseButton.tsx";

type Props = {
	textilizedText: string | null;
	helpIconAltText: string;
	closeText?: string;
};

export function WidgetHelp({
	textilizedText,
	helpIconAltText,
	closeText,
}: Props): React.ReactNode | null {
	const [isVisible, setIsVisible] = React.useState(false);

	if (!textilizedText) {
		return null;
	}

	return (
		<>
			<Modal
				open={isVisible}
				footer={null}
				onCancel={() => setIsVisible(false)}
				styles={{
					body: {
						padding: "34px 0px 34px 24px",
					},
				}}
				width={500}
				closable={false}
				destroyOnHidden
				zIndex={9999}
				centered
			>
				<div data-testid="help-modal">
					<CloseButton onClick={() => setIsVisible(false)} text={closeText} />
					<img
						src="/images/help.png"
						alt={helpIconAltText}
						className="float-left"
					/>
					<div
						className="ml-[100px] max-h-[300px] min-h-[80px] overflow-y-auto pr-[24px]"
						dangerouslySetInnerHTML={createMarkup(textilizedText)}
					/>
				</div>
			</Modal>
			<div className="widget_helpicon">
				<button
					onClick={() => setIsVisible(true)}
					type="button"
					className={getIconClassNames("question-circle")}
					title="Help"
					aria-label="Help"
				/>
			</div>
		</>
	);
}
